/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2PhoneCall/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2PhoneCall({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2PhoneCall",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 12,
  height = 12,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2PhoneCall.Svg"
  data-view-path={viewPath}
 viewBox="0 0 12 12"
 style={{'--as-1-1kii98': alignSelf,'--mt-2-1kii98': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1kii98': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1kii98': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1kii98': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1kii98': opacity,'--w-10-1kii98': typeof width === 'number' ? `${width}px` : width,'--h-11-1kii98': typeof height === 'number' ? `${height}px` : height,'--f-12-1kii98': fill,'--a-7-1kii98': isAnimated ? animation : "none",'--sd-8-1kii98': isAnimated ? strokeDashoffset : 0,'--sd-9-1kii98': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2PhoneCall.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M4.211.414A.67.67 0 003.591 0H.671A.669.669 0 000 .67v2.921a.67.67 0 001.145.475l.986-.986 2.238 2.237a.67.67 0 10.948-.948L3.08 2.13l.986-.986a.67.67 0 00.145-.73zm1.553 11.202a2.414 2.414 0 01-3.014-.322l-.34-.34a.814.814 0 010-1.145l1.43-1.422a.805.805 0 011.137 0 .814.814 0 001.144 0l2.28-2.28a.814.814 0 000-1.145.805.805 0 010-1.136l1.378-1.43a.814.814 0 011.145 0l.34.34a2.414 2.414 0 01.366 3.013 21.669 21.669 0 01-5.866 5.867z"
 style={{'--f-12-1kii98': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}